import {Component, computed, Inject, OnDestroy, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ExtraCost} from '../../../classes/extracost.class';
import {ExtraCostsService} from '../../../services/extraCosts/extra-costs.service';
import {ExtraCostCountType, ExtraCostType} from '../../../classes/extracosttype.class';
import {ConfirmDialogService} from '../../../services/confirm-dialog-service/confirm-dialog.service';
import {Inspection} from '../../../classes/inspection';
import {PricesService} from '../../../services/prices/prices.service';
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {DecimalPipe} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";

export class ExtraCostDialogData {
    extraCost: ExtraCost;
    extraCostsPricesMap: object;
    inspection: Inspection;
}

@Component({
    selector: 'app-extra-costs-dialog',
    templateUrl: './extra-costs-dialog.component.html',
    styleUrls: ['./extra-costs-dialog.component.scss'],
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        FormsModule,
        MatOption,
        MatInput,
        DecimalPipe,
        MatButton,
        MatIconButton
    ]
})
export class ExtraCostsDialogComponent implements OnInit, OnDestroy {

    public readonly extraCost = signal<ExtraCost>(null);
    public readonly extraCosts = signal<ExtraCostType[]>([]);
    public extraCostsPricesMap = {};

    public readonly dialogTitle = computed(() =>
        this.extraCost()?.id ? 'Extra kosten Wijzigen' : 'Extra kosten Toevoegen'
    );
    public readonly buttonLabel = computed(() =>
        this.extraCost()?.id ? 'Wijzigen' : 'Toevoegen'
    );
    public readonly hasId = computed(() => !!this.extraCost()?.id);
    public readonly extraCostTypeUnit = computed(() =>
        this.extraCost()?.extra_cost_type?.unit || ''
    );

    extraCostTypeId: number;
    number: number;
    comment: string;
    extraCostType: ExtraCostType | null = null;

    constructor(
        private extraCostsService: ExtraCostsService,
        private pricesService: PricesService,
        private confirmDialogService: ConfirmDialogService,
        public dialogRef: MatDialogRef<ExtraCostsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public extraCostDialogData: ExtraCostDialogData
    ) {
    }

    ngOnInit() {
        this.extraCost.set(this.extraCostDialogData.extraCost);
        this.extraCostsPricesMap = this.extraCostDialogData.extraCostsPricesMap;

        this.extraCostTypeId = this.extraCost().extra_cost_type_id;
        this.number = this.extraCost().number;
        this.comment = this.extraCost().comment || '';
        this.extraCostType = this.extraCost().extra_cost_type || null;

        if (!this.extraCost()) {
            this.extraCost.set(new ExtraCost());
        }
        this.extraCostsService.getList().then(_extraCosts => {
            this.extraCosts.set(_extraCosts);
            if (this.extraCostTypeId && !this.extraCosts().some(e => e.id === this.extraCostTypeId)) {
                this.extraCosts().push(this.extraCost().extra_cost_type);
            }
        });
    }

    costTypeChanged(event) {
        this.extraCostType = this.extraCosts().find(type => {
            return type.id === event;
        });
        if (this.extraCostType?.count_based_on !== ExtraCostCountType.count) {
            const tempExtraCost = {...this.extraCost(), extra_cost_type: this.extraCostType};
            this.number = Math.round(this.pricesService.extraCostSurfaceCalculation(tempExtraCost) * 100) / 100;
        }
    }

    save() {
        const originalExtraCost = this.extraCost();
        originalExtraCost.inspection_id = this.extraCostDialogData.inspection.id;
        originalExtraCost.extra_cost_type_id = this.extraCostTypeId;
        originalExtraCost.extra_cost_type = this.extraCostType;
        originalExtraCost.number = this.number;
        originalExtraCost.comment = this.comment;

        this.extraCostsService.saveExtraCost(originalExtraCost).then(extraCost => {
            originalExtraCost.id = extraCost.id;
            // Return the updated object to parent
            this.dialogRef.close({updated: originalExtraCost});
        });
    }

    delete() {
        this.confirmDialogService.confirm(
            'Verwijderen',
            'Weet u zeker dat u deze extra kosten wilt verwijderen?',
            'Ja',
            'Nee').then(
            () => {
                if (this.extraCost().id) {
                    this.extraCostsService.deleteExtraCost(this.extraCost().id).then(result => {
                        this.dialogRef.close(true);
                    }, () => {

                    });
                } else {
                    this.dialogRef.close(true);
                }
            }, () => {

            }
        );
    }

    close() {
        this.dialogRef.close((!this.extraCost().id));
    }

    ngOnDestroy(): void {
    }

    protected readonly ExtraCostCountType = ExtraCostCountType;
}

